
import React from 'react';
import MaterialTable from "material-table";
import '../App.css';
import { Chip } from '@material-ui/core';


function Alerts() {
    const url = "/api";
    const token = localStorage.getItem('token');
    var [detRows, setDetRows] = React.useState([]);

    async function computeLogsInformation() {
        let options = {
            method: 'GET',
            mode: 'cors',
            headers: {
                'Content-Type': 'application/json',
                'Accept': '*/*',
                'Access-Control-Allow-Origin': '*',
                'x-access-token': token
            },
        }
        let response = await fetch(url + '/logs', options).catch(err => {
            console.log(err);
        });
        if (response.status !== 200) {
            if (response.status === 401) {
                localStorage.removeItem('token');
            }
            console.log("Can't get the logs information");
        }
        var dataReceived = await response.json();

        var rows = [];
        dataReceived.forEach(log => {
            const dateLast = new Date(log.dateTime);
            const months = [
                '1',
                '2',
                '3',
                '4',
                '5',
                '6',
                '7',
                '8',
                '9',
                '10',
                '11',
                '12'
            ];
            const days = [
                'Domingo',
                'Lunes',
                'Martes',
                'Miércoles',
                'Jueves',
                'Viernes',
                'Sábado'
            ];
            const monthName = months[dateLast.getMonth()];
            const dayName = days[dateLast.getDay()];
            const year = dateLast.getFullYear();
            const dayNum = dateLast.getDate();
            const hours = (0 + dateLast.getHours().toString()).slice(-2);
            const minutes = (0 + dateLast.getMinutes().toString()).slice(-2);
            const seconds = (0 + dateLast.getSeconds().toString()).slice(-2);
            const formattedFecha = `${dayName}, ${dayNum} ${monthName} ${year}`;
            const formattedHora = `${hours}:${minutes}:${seconds}`;

            var lastMessage = "";
            if (dayName !== undefined) {
                lastMessage = formattedFecha + ' a las ' + formattedHora;
                lastMessage = dateLast.getDate() + '/' + monthName + '/' + dateLast.getFullYear() + ' at  ' + formattedHora;
            }


            const message = log.message === "" ? "---" : log.message;
            rows.push({
                id: log.ident === "" ? "---" : log.ident,
                alias: log.alias ? log.alias : "---",
                level: log.level,
                category: log.category,
                user: log.user === "" ? "---" : log.user,
                dateTime: lastMessage,
                message: message,
            });
        });
        return (rows);
    }

    React.useEffect(() => {
        var timer = undefined;
        async function fetchData() {
            var rows = await computeLogsInformation();
            await setDetRows(rows);
            timer = setTimeout(() => {
                fetchData();
            }, 30000);
        }
        fetchData();
        return () => clearTimeout(timer);
    }
        , []); // eslint-disable-line react-hooks/exhaustive-deps


    const data = (rowsData) => {
        return ({
            columns: [
                {
                    title: "Date and Time",
                    field: "dateTime",
                    align: 'center'
                },
                {
                    title: "ID",
                    field: "id",
                    align: 'center'
                },
                {
                    title: "Alias",
                    field: "alias",
                    align: "center"
                },
                {
                    title: "Level",
                    field: "level",
                    align: 'center',
                    render: datos => <Chip label={datos.level} style={{ color: "white", backgroundColor: datos.level === "INFO" ? "#076129" : datos.level === "WARNING" ? "#c66f27" : "#be0000" }} ></Chip>

                },
                {
                    title: "Category",
                    field: "category",
                    align: 'center'
                },
                {
                    title: "User",
                    field: "user",
                    align: 'center'
                },
                {
                    title: "Message",
                    field: "message",
                    align: 'center'
                }
            ],
            rows: rowsData,
        });
    };

    if (detRows !== []) {
        return (
            <div>
                <h1>Logs</h1>
                <br></br>
                <br></br>
                <hr></hr>
                <div style={{ paddingTop: '20px', display: "flex", flexDirection: "column" }}>
                    <MaterialTable
                        title="Log details"
                        data={data(detRows).rows.reverse()}
                        columns={data(detRows).columns}
                        options={{ search: true, paging: true, headerStyle: { fontSize: '1em' }, pageSizeOptions: [20, 50, 100], pageSize: 20 }}
                        style={{ textAlign: 'center' , borderRadius: '20px'}}
                    />
                </div>
            </div>
        );

    }

}

export default Alerts;
